import { Container, Col, Row } from "reactstrap";
import { BreadcrumbItem } from "reactstrap";
import * as DomainQL from "queries/domain";
import * as Notify from "@repoflow/form-schema/notify";
import { CancellableContent } from "@repoflow/components/content-cancel";
import { Mutation, Button } from "@repoflow/components/section";
import { useAccount } from "@repoflow/components/account";

export const Sidebar = () => null;

export const Indice = () => (
  <>
    <BreadcrumbItem>Remove</BreadcrumbItem>
  </>
);

export const Content = ({
  history,
  match: {
    params: { domain },
  },
}) => {
  const account = useAccount();
  return (
    <CancellableContent>
      <Row>
        <Col>
          Removing the domain <b>{domain}</b>? This action will be permanent and
          can't be undone
        </Col>
      </Row>
      <Mutation
        mutation={DomainQL.remove}
        update={DomainQL.update(account)}
        onMutate={({ handler }) => {
          handler({
            variables: {
              domain
            },
          });
        }}
        onCompleted={() => {
          history.replace(`/domain`);
        }}
        onError={(error) => {
          Notify.error(error.toString());
        }}
      >
        {MutationHandler}
      </Mutation>
    </CancellableContent>
  );
};

const MutationHandler = ({ mutate }) => {
  return (
    <Container className="mt-4">
      <Row>
        <Col>
          <Button
            onClick={() => {
              mutate();
            }}
          >
            Remove
          </Button>
        </Col>
      </Row>
    </Container>
  );
};
